import useAuth from "../../Hooks/useAuth";
import usePermission from "../../Hooks/usePermission";
import {
  canUseNotifications,
  canUseNotificationSocket,
  notificationScope,
} from "./notificationConstants";

/**
 * Zil görünür mü? — yalnız merkez: `tasks.access` veya `devices.quota` (bayi ve
 * müşteri görmez, #178). `scope` API adresini seçer. `socketEnabled`: server socket'i bu
 * kullanıcıyı kabul eder mi (değilse polling). `canTasks`: İş Planlama e-posta tercihi
 * gösterilir mi (manuel kota e-postası yok — yalnız zil, #129).
 */
export default function useNotificationAccess() {
  const { auth } = useAuth();
  const { hasPermission } = usePermission();
  const enabled = canUseNotifications(auth?.role, hasPermission);
  const scope = notificationScope(auth?.role);
  return {
    enabled,
    scope,
    canTasks: scope === "storage" && hasPermission("tasks.access"),
    socketEnabled: enabled && canUseNotificationSocket(auth?.role, auth?.permissions || []),
    token: auth?.accessToken,
  };
}
